// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2647":"d21056d1716a7827","2888":"4a3f60519ecb53af","6997":"d21056d1716a7827"}[chunkId] + ".css";
};